import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import Modal from "../../../components/Common/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useFetchData } from "../../../hooks/useFetchData";
import {
  deleteShotclassActionHandler,
  getPublishedByMeActionHandler,
} from "../../../store/actions/actionHandlers/manageActionHandler";
import { publishedByMe } from "../../../utils/mainTabs/manage/publishedByMe";
import classes from "./PublishedByMe.module.scss";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { FormattedMessage } from "react-intl";
const PublishedByMe = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tenantName, refreshAPIS, setRefreshAPIS  } = useOutletContext();
  const manageState = useSelector((state) => state.manageReducer);
  const { deleteShotclassLoader } = manageState;
  const pageSize = 8;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getPublishedByMeActionHandler, pageSize);
  const { searchPlaceHolder, columns } = publishedByMe;
useEffect(() => {
 if(refreshAPIS){
  handleSearchQuery("");
  setRefreshAPIS(false);
 }
}, [refreshAPIS])
  const [shotclassId, setShotclassId] = useState(0);
  const handleDeleteModal = useCallback((shotclassId) => {
    setShotclassId(shotclassId);
  }, []);
  const handleDeleteShotclass = () => {
    dispatch(deleteShotclassActionHandler(shotclassId)).then((isDeleted) => {
      if (isDeleted) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `${
              data.find((shotclass) => shotclass.ID === shotclassId).Name
            } Shotclass successfully deleted`
          )
        );
        const filteredData = data.filter((row) => row.ID !== shotclassId);
        const filteredUpdatedData = updatedData.filter(
          (row) => row.ID !== shotclassId
        );
        setData(filteredData);
        setUpdatedData(filteredUpdatedData);
      }
      handleDeleteModal(0);
    });
  };

  const [tableColumns, setTableColumns] = useState([]);
  useEffect(() => {
    let newTableColumns = columns(navigate, handleDeleteModal, tenantName);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleDeleteModal, tenantName]);

  return (
    <>
      <DataTable
        columns={tableColumns}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"ID"}
        fetchMoreData={handleCurrentPage}
        searchable
        setSearchQuery={handleSearchQuery}
        placeholder={searchPlaceHolder}
      />
      <Modal
        handleSubmit={handleDeleteShotclass}
        isOpen={shotclassId}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={() => handleDeleteModal(0)}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
        loading={deleteShotclassLoader}
      >
        <div className={classes.publishedByMe__deleteModal}>
          <div className={classes.publishedByMe__deleteModal__text}>
            <FormattedMessage id="MYCLASS_POPUP_MSG" />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PublishedByMe;
